import { MetadataAuthoringRule } from '@adaptiva/metadata/common';
import { IReferenceMetadataAuthoringRule } from '../interfaces';

export class ReferenceMetadataAuthoringRule implements IReferenceMetadataAuthoringRule {

	public type: int;

	public reference: int;

	constructor(_reference?: int) {
		this.type = MetadataAuthoringRule.REFERENCE;
		if (_reference) {
			this.reference = _reference;
		}
	}
}
